import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.image-text-button-swiper').forEach((el) => {
    const slides = el.querySelectorAll('.swiper-slide');
    if (slides.length < 2) return;

    const shouldAutoscroll = el.dataset.autoscroll === 'true';
    const delay = parseInt(el.dataset.delay || '3000', 10);

    new Swiper(el, {
      modules: [Navigation, Pagination, Keyboard, Autoplay],
      loop: true,
      autoplay: shouldAutoscroll
        ? {
            delay: delay,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }
        : false,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      speed: 500,
    });
  });
});
